module.exports = __webpack_public_path__ + "img/phone.f226ea20.png";